export const defaultSelectedDate = () => {
    var fecha = new Date();
    var month = fecha.getMonth();
    return  `${fecha.getFullYear()}${month>9?month:"0"+month}`;

};

export const defaultSelectedDateFrom = () => {
    var fecha = new Date();
    return  `${fecha.getFullYear()}01`;

};

export default {
    ag_grid: {
        selectedTheme: 'ag-theme-balham'
    },
    params: {
        count_months:0,
        year_month_from: defaultSelectedDateFrom(),
        year_month_up: defaultSelectedDate(),
        option:1,
        months:[],
        view_delete_from: null,
        view_delete_up: null,
    },
    account_report: [],
    loading: {
        module: false
    },
    months:[
        {
            id:'01',
            name:'Enero'
        },
        {
            id:'02',
            name:'Febrero'
        },
        {
            id:'03',
            name:'Marzo'
        },
        {
            id:'04',
            name:'Abril'
        },
        {
            id:'05',
            name:'Mayo'
        },
        {
            id:'06',
            name:'Junio'
        },
        {
            id:'07',
            name:'Julio'
        },
        {
            id:'08',
            name:'Agosto'
        },
        {
            id:'09',
            name:'Septiembre'
        },
        {
            id:'10',
            name:'Octubre'
        },
        {
            id:'11',
            name:'Noviembre'
        },
        {
            id:'12',
            name:'Diciembre'
        },
    ],
    monts_fields :[]
};



// WEBPACK FOOTER //
// ./src/modules/report-reult-eri/state.js